import React from 'react';

import { useOverlayLoader } from '@context/OverlayLoaderContext';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export const LoaderOverlay: React.FC<{ isLoading?: boolean } & CircularProgressProps> = () => {
  const { isLoading, message } = useOverlayLoader();

  if (!isLoading) return null;

  return (
    <div className="loader-overlay tag-ds">
      <div className="loader-centred">
        <CircularProgress />
        <p>{message}</p>
      </div>
    </div>
  );
};
